import { render } from "./ProtocolList.vue?vue&type=template&id=13c665c0&scoped=true"
import script from "./ProtocolList.vue?vue&type=script&lang=js"
export * from "./ProtocolList.vue?vue&type=script&lang=js"

import "./ProtocolList.vue?vue&type=style&index=0&id=13c665c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c665c0"]])

export default __exports__